import script from "./VueEasyLightbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./VueEasyLightbox.vue?vue&type=script&lang=ts&setup=true"

import "./VueEasyLightbox.vue?vue&type=style&index=0&id=01d4de22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d4de22"]])

export default __exports__